import { render, staticRenderFns } from "./loginEn.vue?vue&type=template&id=5653bc1a&scoped=true"
import script from "./loginEn.vue?vue&type=script&lang=js"
export * from "./loginEn.vue?vue&type=script&lang=js"
import style0 from "./loginEn.vue?vue&type=style&index=0&id=5653bc1a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5653bc1a",
  null
  
)

export default component.exports